/* Constants */
import { assertCondition } from '../../../../utils/types';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IStateHint } from '../../../../utils/stateHint';
import { IAnalysesState } from '../types';

export const toggleIsConversionView = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    analysisId: any;
    value: any;
  }>,
) => {
  const { analysisId, value } = action.payload;
  const chartSettings = draft[analysisId].settings.chartSettings;
  chartSettings.isConversionView = !!value;
  return;
};

export const toggleConversionLabels = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    analysisId: any;
    value: any;
  }>,
) => {
  const { analysisId, value } = action.payload;
  const chartSettings = draft[analysisId].settings.chartSettings;
  chartSettings.isShowFunnelConversionLabels = !!value;
  return;
};

export const toggleBounceLabels = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    analysisId: any;
    value: any;
  }>,
) => {
  const { analysisId, value } = action.payload;
  const chartSettings = draft[analysisId].settings.chartSettings;
  chartSettings.isShowFunnelBounceLabels = !!value;
  return;
};

export const toggleIsRelativeLabels = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    analysisId: string;
    value: any;
  }>,
) => {
  const { analysisId, value } = action.payload;
  const chartSettings = draft[analysisId].settings.chartSettings;
  chartSettings.isFunnelRelativeLabels = !!value;
  return;
};

export const toggleClusterLabels = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    analysisId: any;
    value: boolean;
  }>,
) => {
  const { analysisId, value } = action.payload;
  const chartSettings = draft[analysisId].settings.chartSettings;
  chartSettings.isFunnelClusterMode = !!value;
  return;
};

export const setFunnelShowInReportState = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    analysisId: string;
    showInReportState: IStateHint;
  }>,
) => {
  const { analysisId, showInReportState } = action.payload;

  const chartData = draft[analysisId].chartData;
  assertCondition(chartData?.queryType === QueryType.Funnel);

  chartData.showInReportState = showInReportState;
};
